import { NgModule } from "@angular/core";

import { SearchComponent } from "./search.component";

@NgModule({
  imports: [SearchComponent],
  exports: [SearchComponent],
})
export class SearchModule {}
